import { useEffect, useState } from 'react'

import { orders } from '../api/services/orders'
import {
  OrderExtendedDetails,
  OrderExtendedProfile
} from '../api/services/orders/types.ts'

const useOrdersHistory = ({
  currentOrderId,
  patientProfileId
}: {
  currentOrderId: number
  patientProfileId: number
}) => {
  const [loading, setLoading] = useState(false)
  const [ordersList, setOrdersList] = useState<OrderExtendedProfile[] | null>(
    null
  )

  const fetchOrders = async () => {
    try {
      setLoading(true)
      const params = `?patient_profile=${patientProfileId}`
      const response = await orders.getOrders(params)
      if (response.results.length > 0) {
        const ordersListExcludedCurrentOrder = response.results.filter(
          (order: OrderExtendedProfile) => order.id !== currentOrderId
        )
        setOrdersList(ordersListExcludedCurrentOrder)
      } else {
        setOrdersList([] as OrderExtendedDetails[])
      }
    } catch {
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (ordersList === null) fetchOrders()
  }, [currentOrderId, patientProfileId])

  return { loading, ordersList }
}

export default useOrdersHistory
